const config = {
    apiGateway: {
        REGION: 'eu-central-1',
        URL: 'https://egnpglk581.execute-api.eu-central-1.amazonaws.com/prod/graphql/api',
        ESURL: 'https://egnpglk581.execute-api.eu-central-1.amazonaws.com/prod/search/api',
    },
    cognito: {
        REGION: 'eu-central-1',
        USER_POOL_ID: 'eu-central-1_QROiAWiz9',
        APP_CLIENT_ID: '17a29gtogmiq3suhvqenggeht7',
        DOMAIN: 'datahubvaleucentral1453330716657.auth.eu-central-1.amazoncognito.com',
        REDIRECT_URI: 'https://datahub-val.novonordisk.com',
        SIGNOUT_URL: 'https://datahub-val.novonordisk.com',
        provider: 'Okta',
    },
    cloudWatch: {
        APPLICATION_ID: '',
        IDENTITY_POOL_ID: '',
        GUEST_ROLE_ARN: '',
    },
};

const exportedConfig = {
    ...config,
};

export default exportedConfig;
